import type { Options } from 'highcharts'

import { SMALL_MODAL } from 'consts/modalStyles'
import { humanizeLargeNumber } from 'utils'

export const MODAL_STYLE = {
  ...SMALL_MODAL,
  content: {
    ...SMALL_MODAL.content,
    padding: '0px',
  },
}

export const PIN_TYPE_TO_FIELD_MAP = {
  creators: 'creatorAmount',
  posts: 'postAmount',
  videos: 'postAmount',
  subtopics: 'territoriesAmount',
  topics: 'territoriesAmount',
  industry_topic: 'territoriesAmount',
  hot_topic: 'territoriesAmount',
  savedPostSearches: 'territoriesAmount',
  tags: 'territoriesAmount',
  saved_searches: 'territoriesAmount',
  niches: 'territoriesAmount',
  trendings: 'territoriesAmount',
} as const

export const COMMON_DASHBOARD_CHART_CONFIGS: Options = {
  legend: {
    navigation: {
      arrowSize: 8,
      style: {
        fontSize: '12px',
      },
    },
  },
  plotOptions: {
    series: {
      animation: false,
    },
  },
  chart: {
    animation: false,
  },
}

export const DASHBOARD_LINE_CHART_CONFIG: Options = {
  ...COMMON_DASHBOARD_CHART_CONFIGS,
  yAxis: {
    labels: {
      formatter: function () {
        return humanizeLargeNumber(Number(this.value ?? 0), 1)
      },
    },
  },
}

export const DASHBOARD_SCATTER_CHART_CONFIG: Options = {
  ...COMMON_DASHBOARD_CHART_CONFIGS,
  xAxis: {
    title: {
      style: {
        fontSize: '11px',
      },
    },
    labels: {
      formatter: function () {
        return humanizeLargeNumber(Number(this.value ?? 0), 1)
      },
    },
  },
  yAxis: {
    title: {
      style: {
        fontSize: '11px',
      },
    },
    labels: {
      formatter: function () {
        return humanizeLargeNumber(Number(this.value ?? 0), 1)
      },
    },
  },
}

export const DASHBOARD_COLUMN_CHART_CONFIG: Options = {
  ...COMMON_DASHBOARD_CHART_CONFIGS,
  xAxis: {
    visible: false,
  },
  yAxis: {
    labels: {
      formatter: function () {
        return humanizeLargeNumber(Number(this.value ?? 0), 1)
      },
    },
  },

  plotOptions: {
    ...COMMON_DASHBOARD_CHART_CONFIGS.plotOptions,
    column: {
      centerInCategory: false,
      groupPadding: 0,
    },
  },
}

export const DASHBOARD_STACKED_CHART_CONFIG: Options = {
  ...COMMON_DASHBOARD_CHART_CONFIGS,
  yAxis: {
    ceiling: 100,
    endOnTick: true,
    maxPadding: 0.05,
  },
  plotOptions: {
    ...COMMON_DASHBOARD_CHART_CONFIGS.plotOptions,
    column: {
      stacking: 'percent',
      dataLabels: {
        enabled: true,
        format: '{point.percentage:.0f}%',
        style: { fontSize: '9px' },
      },
    },
  },
}
